import * as React from 'react'
import ImageZoom from 'react-image-zooom'
import TouchAppOutlinedIcon from '@mui/icons-material/TouchAppOutlined'
import CountryDropDown from '../downloads/countrydropdown'
const Zoomable = ({
  src,
  dld,
  caption,
  id,
  interact,
  download,
  zoom,
  alt,
  name,
  dropdown
}) => {

  const sizeCol = (caption == '') ? 'col-md-12 text-left': 'col-md-3 text-right'
  return (
    <section className='section-zoomable'>
      <div id={id} className='row'>
        <div className='col-md-12'>
        <div
                className='d-none d-md-block small'
                style={{ opacity: '0.6' }}
              >
                <TouchAppOutlinedIcon></TouchAppOutlinedIcon>
                {interact}
              </div>
        </div>
        <div className='col-md-12'>
          <ImageZoom src={src} alt={alt} zoom={zoom} />
        </div>
        <div className={dld != '' ? 'col-md-9' : 'col-md-12'}>
          <figure>
            <figcaption>
              <span className='small'>{caption}</span>
              
            </figcaption>
          </figure>
        </div>
        {dropdown ? (
        <CountryDropDown
        options={dropdown}
          />): null}
        {dld != '' ? (
          <div className={sizeCol}>
            <a
              className='download-infographic fw-normal is-button'
              href={dld}
              download
              data-name={name}
              target='_blank'
            >
              {' '}
              {download} <span className='arr'>→</span>
            </a>
          </div>
        ) : null}
      </div>
    </section>
  )
}

export default Zoomable
